import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import App from './App.vue'
import { createPinia } from 'pinia'
import { cachePlugin } from './store/cachePlugin'
import { directive } from './utils/directive'
import { router } from './router'
import { i18n } from './i18n'
import { HighchartsConfig } from '@/utils/hightCharts'
import { registerEcharts } from '@/plugins/echarts'
import 'virtual:svg-icons-register'
import '@/components/design-form/index.scss'
import './App.scss'
import '@/icons/iconfont/iconfont_maku'
import '@/icons/iconfont/iconfont'
import '@/icons/iconfont/iconfont.css'
import 'element-plus/dist/index.css'
import '@/styles/index.scss'
import 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'
//import '@/utils/flexible.ts'
import { dayjs } from 'element-plus'
// dayjs.en.weekStart = 1
import 'dayjs/locale/zh-cn'
import 'virtual:svg-icons-register' // 引入注册脚本
import SvgIcon from '@/components/SvgIcon.vue' // 引入组件
dayjs.locale('zh-cn')

import MaComponent from '@/components/index'
import cache from '@/utils/cache'
import { checkBrowserSupport } from '@/utils/performance'
import PerformanceMonitor from '@/components/PerformanceMonitor.vue'
import { initAppConfig } from '@/utils/appConfig'

// 导入所有 Element Plus 语言包
import element_zh_cn from 'element-plus/es/locale/lang/zh-cn'
import element_en from 'element-plus/es/locale/lang/en'
import element_es from 'element-plus/es/locale/lang/es'

// 根据缓存的语言获取对应的 Element Plus locale
const getElLocale = () => {
	const lang = cache.getLanguage() || 'zh-CN'
	switch (lang) {
		case 'en-US':
			return element_en
		case 'es-ES':
			return element_es
		case 'zh-CN':
		default:
			return element_zh_cn
	}
}

const elLocale = getElLocale()

// 检查浏览器支持情况
const browserSupport = checkBrowserSupport()
console.log('Browser Support:', browserSupport)

VXETable.config({
	zIndex: 3000,
	select: {
		transfer: true
	}
})

const app = createApp(App)

// 注册性能监控组件
app.component('PerformanceMonitor', PerformanceMonitor)
app.component('SvgIcon', SvgIcon)
const pinia = createPinia()
pinia.use(cachePlugin)
app.use(pinia)
registerEcharts(app)
// element plus图标 全局注册
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
	app.component(key, component)
}

// flowable 流程设计器
import '@/components/process-designer/package/theme/index.scss'
import ProcessDesigner from '@/components/process-designer/package/index.js'
app.use(ProcessDesigner)
HighchartsConfig()
// 注册 自定义指令
directive(app)
app.use(i18n)
app.use(router)
app.use(MaComponent)
app.use(ElementPlus, {
	locale: elLocale
})
app.use(VXETable)

// 错误处理
app.config.errorHandler = (err, vm, info) => {
	console.error('Vue Error:', err)
	console.error('Error Info:', info)
}

// 性能优化：预加载关键资源
const preloadCriticalResources = () => {
	const criticalResources = ['/fonts/iconfont.woff2', '/images/logo.png', window.location.origin + '/webpublish/']

	criticalResources.forEach(resource => {
		const link = document.createElement('link')
		link.rel = 'preload'
		link.as = resource.endsWith('.woff2') ? 'font' : resource.endsWith('.png') ? 'image' : 'document'
		link.href = resource
		document.head.appendChild(link)
	})
}

// 在应用挂载前预加载资源
preloadCriticalResources()

// 初始化应用配置
initAppConfig()
	.then(() => {
		app.mount('#app')
	})
	.catch(error => {
		app.mount('#app')
	})
